import { render, staticRenderFns } from "./GameCard.vue?vue&type=template&id=21cf6692&scoped=true"
import script from "./GameCard.vue?vue&type=script&lang=ts"
export * from "./GameCard.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GameCard.vue?vue&type=style&index=0&id=21cf6692&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "21cf6692",
  "1f2f95c6"
  
)

export default component.exports